import React, { memo, useMemo } from 'react';
import { connect } from 'react-redux';
import { axios, fetchInstance } from 'services';
import { Web5Provider } from '@Sage/ssm-web5';
import { notifyBugsnagError } from 'BugSnagWrapper';
import Context from 'managers/Context';
import { NEW_API_URL, B2_URL, FORCE_BI_URL, PATH_IMAGE } from 'constants/Environment';
import * as FmBridgeBackend from '@Sage/fm-bridge-backend';
import { logEvent } from 'utils/tracking';
import { getEntityFromString } from 'utils/getEntityFromString';
import { getDecimalsByConfig, formatDecimalByConfig, DECIMAL_TYPES } from 'utils/decimal';
import {
    COMPANIES,
    CONTACTS,
    OPPORTUNITIES,
    ACTIVITIES,
    AGENDA,
    SALESORDERS,
    DOCUMENTS,
    PRODUCTS,
    KPIS,
    BILLBOARD,
    CAMPAIGNS,
    CONVERSATIONS,
    METRICS,
    ANALYTICS_REPORT,
    DASHBOARD,
} from 'constants/Entities';
import { DEFAULT_THEME } from 'lib/metadata';

const reportError = (error, metadata) => {
    notifyBugsnagError(error, metadata);
};

const Web5ProviderContext = ({ children, literals, theme = DEFAULT_THEME, userTimezone }) => {
    const providerProps = useMemo(
        () => ({
            children,
            context: {
                apiBaseURL: NEW_API_URL,
                axiosInstance: axios,
                b2URL: B2_URL,
                bridgeBackend: FmBridgeBackend,
                email: Context.config?.userData?.email,
                entities: {
                    ACTIVITIES,
                    AGENDA,
                    ANALYTICS_REPORT,
                    BILLBOARD,
                    CAMPAIGNS,
                    COMPANIES,
                    CONTACTS,
                    CONVERSATIONS,
                    DASHBOARD,
                    DOCUMENTS,
                    KPIS,
                    METRICS,
                    OPPORTUNITIES,
                    PRODUCTS,
                    SALESORDERS,
                },
                fetchInstance,
                forceBIURL: FORCE_BI_URL,
                getDecimalsByConfig,
                formatDecimalByConfig,
                DECIMAL_TYPES,
                getWeb4EntityFromString: getEntityFromString,
                implementation: parseInt(Context.config?.userData?.idImplementacion, 10),
                language: Context.config?.userData?.langISOInterface,
                locale: Context.config?.userData?.locale,
                locales: literals,
                logEvent,
                pathImage: PATH_IMAGE,
                platform: 101,
                reportError,
                token: Context.config?.token,
                userTimezone,
            },
            theme: theme || DEFAULT_THEME,
        }),
        [children, literals, theme, userTimezone],
    );
    return <Web5Provider {...providerProps} />;
};

const mapStateToProps = (state) => {
    const idTimeZone = state.config?.userData?.idTimeZone;
    const timezones = state.serverList?.fm_iana_time_zone?.data || [];
    const userTimezoneEntry = timezones.find(
        (timezone) => parseInt(timezone.value, 10) === parseInt(idTimeZone, 10),
    );
    const userTimezone =
        userTimezoneEntry?.idianazone ||
        (typeof Intl !== 'undefined' ? Intl.DateTimeFormat().resolvedOptions().timeZone : 'UTC');

    return {
        literals: state.literal?.literals,
        userTimezone,
    };
};

export default memo(connect(mapStateToProps)(Web5ProviderContext));
